import React, { Component } from "react";
import settings from "../../settings.json";
import { comment } from "../../assets";
import { Link, withRouter } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-daterangepicker/daterangepicker.css";
import ReactHtmlParser from "react-html-parser";
import "./package.scss";
import Carousel, { Modal, ModalGateway } from "react-images";
import translate from "../../translate.json";

class Package extends Component {
  constructor(props) {
    super(props);
    this.settings = {
      domain:
        window.location.hostname !== "localhost"
          ? window.location.hostname
          : settings.domain,
      protocol: settings.protocol + "//",
    };
    this.queryString = require("query-string");
    this.bookedDates = [];
    this.invalidDate = [];

    this.state = {
      startDate: "",
      endDate: "",
      modalIsOpen: false,
      customersWord: [],
      selectedIndex: 0,
      packageName: this.queryString.parse(this.props.location.search).package,
      packageId: this.queryString.parse(this.props.location.search).id,
      mapedPackage: [],
      mainImage: "",
    };

    this.axios = require("axios");
    this.getPackage();
    this.getFrontPage();
  }
  scrollToFu = () => {
    var widthPerc = window.innerWidth;
    if (widthPerc <= 768) {
      setTimeout(() => {
        window.scrollTo({
          top: widthPerc,
          behavior: "smooth",
        });
      }, 100);
    }
  };

  getBooked() {
    return this.axios
      .post(
        "" +
          this.settings.protocol +
          this.settings.domain +
          "/php/getBookedPackage.php"
      )
      .then(function (response) {
        // handle success
        return response.data;
      })
      .catch(function (error) {
        // handle error
        return error;
      });
  }

  getFrontPage() {
    return this.axios
      .post(
        "" +
          this.settings.protocol +
          this.settings.domain +
          "/php/getFrontPage.php"
      )
      .then((response) => {
        this.setState({
          customersWord: JSON.parse(response.data.customersWord),
        });
      });
  }

  getPackage() {
    this.axios
      .post(
        "" +
          this.settings.protocol +
          this.settings.domain +
          "/php/getPackages.php"
      )
      .then((response) => {
        console.log(response)
        var packageImage = [];
        var packageLargeImage = [];
        response.data.forEach((packageOffer, i) => {
          if (packageOffer.id === this.state.packageId) {
            this.setState({
              maxGuests: packageOffer.maxGuests,
              dateRange: packageOffer.dateRange,
              mainImage: packageOffer.mainImage,
            });
            JSON.parse(packageOffer.gallery).forEach((value, index) => {
              const img =
                "" +
                this.settings.protocol +
                this.settings.domain +
                "/uploads/" +
                value;
              const imgThumb =
                "" +
                this.settings.protocol +
                this.settings.domain +
                "/uploads/medium_" +
                value;
              packageLargeImage.push({ src: img });
              packageImage.push(
                <div
                  key={index}
                  onClick={() => this.toggleModal(index)}
                  className="cabin-image"
                >
                  <img alt="gallery" src={imgThumb} />
                </div>
              );
            });
          }
        });
        this.setState({
          packageImage,
          packageLargeImage,
        });
        var placeholderInvalidDates = [];
        const mapedPackage = response.data.map((packageOffer, i) => {
          placeholderInvalidDates.push({
            packageName: packageOffer.packageName,
            dates: [],
          });
          if (this.state.packageId === packageOffer.id) {
            packageOffer.selected = true;
          }
          return packageOffer;
        });
        var packageInfo = "";

        response.data.forEach((packageOffer) => {
          if (packageOffer.id === this.state.packageId) {
            packageInfo = (
              <span>
                <h1>
                  {ReactHtmlParser(
                    settings.lang === "en"
                      ? packageOffer.packageName
                      : packageOffer.packageNameFo
                  )}
                </h1>
                {ReactHtmlParser(
                  settings.lang === "en"
                    ? packageOffer.textLong
                    : packageOffer.textLongFo
                )}
              </span>
            );
          }
        });
        this.setState({ mapedPackage, packageInfo });
        sessionStorage.setItem(
          "currentState",
          JSON.stringify(this.state.mapedPackage)
        );
      })
      .catch((error) => {
        console.log(error);
      });
  }
  getDates(start, end) {
    var arr = [];
    var dt = new Date(start);

    while (dt <= end) {
      arr.push(new Date(dt).valueOf());
      dt.setDate(dt.getDate() + 1);
    }
    return arr;
  }

  toggleModal = (index) => {
    this.setState(() => ({
      modalIsOpen: !this.state.modalIsOpen,
      selectedIndex: index,
    }));
  };

  render() {
    const { modalIsOpen } = this.state;
    return (
      <content id="cabins">
        <div className="carousel">
          <img
            alt="img"
            src={
              this.state.mainImage !== ""
                ? "" +
                  this.settings.protocol +
                  this.settings.domain +
                  "/uploads/full_" +
                  this.state.mainImage
                : ""
            }
          />
        </div>
        <div className="about">
          <div className="about-content1">
            {this.state.packageInfo}
            <div className="all-btn">
              <Link
                className="book-now"
                to={"packageAvailability?id=" + this.state.packageId}
              >
                <div>{translate.startBooking[settings.lang]}</div>
              </Link>
            </div>
          </div>
          <div className="about-content2">
            <div>
              <div className="comment">
                <img alt="img" src={comment} />
                <p>{translate.fewWord[settings.lang]}:</p>
                {ReactHtmlParser(this.state.customersWord.comment)}
              </div>
            </div>
          </div>
        </div>
        <div className="cabin-gallery">
          <div className="wrap-cabin-gallery">
            <h1>{translate.gallery[settings.lang]}</h1>
            {this.state.packageImage}
            <ModalGateway>
              {modalIsOpen ? (
                <Modal onClose={this.toggleModal}>
                  <Carousel
                    frameProps={{ autoSize: "height" }}
                    currentIndex={this.state.selectedIndex}
                    views={this.state.packageLargeImage}
                  />
                </Modal>
              ) : null}
            </ModalGateway>
          </div>
        </div>
      </content>
    );
  }
}

export default withRouter(Package);
